import React from 'react'
import { useDispatch } from 'react-redux'
import { npsLinks } from '../../parameters'
import { isGE } from '../Device'
import { withEmptyFallbackErrorBoundary } from '../error/EmptyFallbackErrorBoundary'
import cross from '../genericComponents/assets/cross.svg'
import RectangleActionButton, {
  COLOR_GREY_EMPTY,
  SIZE_MEDIUM,
} from '../genericComponents/buttons/RectangleActionButton'
import T from '../i18n/T'
import SVGIcon from '../svg/SVGIcon'
import { withEverySelectorTruthy } from '../utils/react-redux'
import s from './NPSSurvey.less'
import { selectShouldDisplayNPSSurvey } from '../../store/incentive/incentive.selectors'
import { setNPSSurveyDisplayed } from '../../store/incentive/incentiveSlice'

const useNPSLinks = () => (isGE() ? npsLinks.itinerary_results_desktop : npsLinks.itinerary_results_mobile)

const ParticipateButton = ({ closeSurvey }) => {
  const href = useNPSLinks()

  return (
    <RectangleActionButton
      className={s.participateButton}
      color={COLOR_GREY_EMPTY}
      label="survey.ok_button"
      href={href}
      targetBlank
      nofollow
      onClick={closeSurvey}
      size={SIZE_MEDIUM}
    />
  )
}

const CloseButton = ({ closeSurvey }) => (
  <button className={s.closeButton} onClick={closeSurvey}>
    <SVGIcon url={cross} inlineSvg />
  </button>
)

const NPSSurvey = () => {
  const dispatch = useDispatch()
  const closeSurvey = () => dispatch(setNPSSurveyDisplayed())

  return (
    <div className={s.NPSSurvey}>
      <div className={s.content}>
        <p className={s.title}>
          <T id="survey.title" />
        </p>
        <p className={s.description}>
          <T id="survey.description" />
          <ParticipateButton closeSurvey={closeSurvey} />
        </p>
        <CloseButton closeSurvey={closeSurvey} />
      </div>
    </div>
  )
}

// webpack:BrowserOnly
export default withEmptyFallbackErrorBoundary(withEverySelectorTruthy(selectShouldDisplayNPSSurvey)(NPSSurvey))
